import createdDate from './createdDate';
import modifiedDate from './modifiedDate';
import tags from './tag';
import productCategories from './productCategories';
import productTypes from './productTypes';
import productPresetGroups from './productPresetGroups';
import thumbnailUrl from './thumbnailUrl';
import alert from './alerts';
import tracked from './tracked';
import bundle from './bundle';
import { serialNumberRequired } from './serial-number-required';

export const inventoryFilters = [alert, createdDate, tracked];

export default [
  tags,
  productPresetGroups,
  productTypes,
  productCategories,
  createdDate,
  modifiedDate,
  thumbnailUrl,
  bundle,
  serialNumberRequired,
];
